<script setup>
import { reactiveOmit } from '@vueuse/core';
import { DatePickerCell, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';

const props = defineProps({
    date: { type: null, required: true },
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
    class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <DatePickerCell
        :class="
            cn(
                'relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:rounded-full [&:has([data-selected])]:bg-accent [&:has([data-selected])]:text-white [&:has([data-selected][data-outside-view])]:bg-accent/50',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </DatePickerCell>
</template>
